import React from "react";
import WidgetsWrapper from "./widgets-wrapper";
import WidgetRowContainer from "./widgets-row-container";

export class Layouter extends React.Component {
  render() {
    const { widgetRows, socket } = this.props;
    return (
      <WidgetsWrapper wrapperClasses="row-container">
        <WidgetRowContainer socket={socket} widgets={widgetRows}></WidgetRowContainer>
      </WidgetsWrapper>
    );
  }
}
